/* eslint-disable max-lines-per-function */
import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Upsert from '../../components/form/Upsert'
import Modal from '../../components/popup/Modal'

const fields1 = ['hoTen', 'cccd', 'gioiTinh', 'ngaySinh', 'noiSinh', 'danToc']
const col1 = { hoTen: 4, cccd: 4, gioiTinh: 4, ngaySinh: 4, noiSinh: 4, danToc: 4 }
const name1 = {
  hoTen: 'Họ tên',
  cccd: 'Căn cước công dân',
  gioiTinh: 'Giới tính',
  ngaySinh: 'Ngày sinh',
  noiSinh: 'Nơi sinh',
  danToc: 'Dân tộc',
}
const types1 = { gioiTinh: 'select', ngaySinh: 'date' }
const gioiTinhs = [
  { name: 'Nam', id: 1 },
  { name: 'Nữ', id: 2 },
  { name: 'Khác', id: 3 },
]
const options1 = { gioiTinh: gioiTinhs }
const required1 = ['hoTen', 'gioiTinh', 'ngaySinh', 'noiSinh', 'danToc']
const maxLength1 = { hoTen: 100, noiSinh: 80, danToc: 20 }

const numberOfDiem = 6
const setDiemFiels = () => {
  const rsDiem = []
  const rsCol = {}
  const rsName = {}
  const rsDiemMonTypes = {}
  for (let i = 1; i <= numberOfDiem; i++) {
    const monName = `mon${i}`
    const diemMonName = `diemMon${i}`
    rsDiem.push(monName)
    rsDiem.push(diemMonName)
    rsCol[monName] = 3
    rsCol[diemMonName] = 3
    rsName[monName] = `Môn ${i}`
    rsName[diemMonName] = `Điểm môn ${i}`
    rsDiemMonTypes[monName] = 'select'
  }
  return { rsDiem, rsCol, rsName, rsDiemMonTypes }
}
// const diemMonOptions = (options) => {
// const rsDiemMonOption = {}
// for (let i = 1; i <= numberOfDiem; i++) {
// const diemMonName = `mon${i}`
// rsDiemMonOption[diemMonName] = options.map((item) => {
// return { name: item.name, id: item.code }
// })
// }
// return rsDiemMonOption
// }
const monSetup = setDiemFiels()

// const fields2 = ['truongId', 'hanhKiem', 'hocLuc', ...monSetup.rsDiem, 'ketQua', 'xepLoai']
const fields2 = ['truongId', 'hanhKiem', 'hocLuc', 'ketQua', 'xepLoai']
const col2 = { truongId: 4, hanhKiem: 4, hocLuc: 4, ketQua: 4, xepLoai: 4, ...monSetup.rsCol }
const name2 = {
  truongId: 'Trường',
  hanhKiem: 'Hạnh kiểm',
  hocLuc: 'Học lực',
  ketQua: 'Kết quả',
  xepLoai: 'Xếp loại',
  ...monSetup.rsName,
}
const types2 = { truongId: 'select', ketQua: 'select', ...monSetup.rsDiemMonTypes }
const ketQuas = [
  { name: 'Đạt', id: true },
  { name: 'Không đạt', id: false },
]
const required2 = ['truongId']
const maxLength2 = { hanhKiem: 20, hocLuc: 20, xepLoai: 20 }

const fields3 = [
  'heDaoTaoId',
  'hinhThucDaoTaoId',
  'donViDangKyDuThiId',
  // 'hoiDongId',
  'soHieu',
  // 'soCapBang',
  'khoaThiId',
  'ngayKy',
  'nguoiKy',
  'ngayCapBang',
  'ghiChu',
]
const col3 = {
  hoiDongId: 12,
  donViDangKyDuThiId: 12,
  soHieu: 4,
  soCapBang: 4,
  khoaThiId: 4,
  ngayKy: 4,
  nguoiKy: 4,
  ngayCapBang: 4,
  ghiChu: 12,
}
const name3 = {
  heDaoTaoId: 'Hệ đào tạo',
  hinhThucDaoTaoId: 'Hình thức đào tạo',
  donViDangKyDuThiId: 'Trường tốt nghiệp',
  hoiDongId: 'Hội đồng',
  soHieu: 'Số hiệu',
  soCapBang: 'Số cấp bằng',
  khoaThiId: 'Khoá thi',
  ngayKy: 'Ngày ký',
  nguoiKy: 'Người ký',
  ngayCapBang: 'Ngày cấp bằng',
  ghiChu: 'Ghi chú',
}
const types3 = {
  heDaoTaoId: 'select',
  hinhThucDaoTaoId: 'select',
  donViDangKyDuThiId: 'select',
  hoiDongId: 'select',
  khoaThiId: 'select',
  ghiChu: 'text-area',
}
const required3 = [
  'heDaoTaoId',
  'hinhThucDaoTaoId',
  'donViDangKyDuThiId',
  'hoiDongId',
  'soHieu',
  'soCapBang',
  'khoaThiId',
]
const maxLength3 = { soHieu: 20, soCapBang: 20 }

const renderButton = ({ toggle, canEdit, btnProps }) => {
  const additionProp = btnProps || {}
  return (
    <div>
      <Button
        icon={canEdit ? 'pi pi-pencil' : 'pi pi-eye'}
        className={`p-button-rounded ${canEdit ? 'p-button-success' : 'p-button-info'} mr-2`}
        onClick={toggle}
        {...additionProp}
        tooltip={canEdit ? 'Sửa' : 'Xem'}
        tooltipOptions={{ position: 'top' }}
      />
    </div>
  )
}

const ViewVanBang = (props) => {
  const {
    khoaThis,
    donViDangKyDuThis,
    heDaoTaos,
    hinhThucDaoTaos,
    truongs,
    hoiDongs,
    // monThis,
  } = useSelector((item) => {
    const { khoaThi, donViDangKyDuThi, heDaoTao, hinhThucDaoTao, truong, hoiDong, monThi } = item
    return {
      khoaThis: khoaThi.datas,
      donViDangKyDuThis: donViDangKyDuThi.datas,
      heDaoTaos: heDaoTao.datas,
      hinhThucDaoTaos: hinhThucDaoTao.datas,
      truongs: truong.datas,
      hoiDongs: hoiDong.datas,
      monThis: monThi.datas,
    }
  })
  const { action, data, disabled, disabledAll, canEdit, btnProps } = props
  const [visible, setVisible] = useState(false)
  const toggle = () => setVisible(!visible)

  const [values, setValues] = useState({ ...data })
  const [error, setError] = useState({})
  useEffect(() => {
    setValues({ ...data })
  }, [data, visible])

  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button label="Huỷ" className="p-button-secondary mr-2" onClick={toggle} />
      {canEdit && (
        <Button
          label="Lưu"
          onClick={async () => {
            const newError = {}
            const required = [...required1, ...required2, ...required3]
            const name = { ...name1, ...name2, ...name3 }
            const fields = [...fields1, ...fields2, ...fields3]
            required.forEach((key) => {
              if (!fields.find((i) => key === i)) {
                return
              }
              if (values[key] === '' || values[key] === undefined || values[key] === null) {
                newError[key] = `Trường ${name[key] || key} là bắt buộc!`
              }
            })
            setError(newError)
            if (Object.keys(newError).length === 0) {
              const { files } = document.getElementById('fileUploader')
              if (files.length > 0) {
                const firstIndex = 0
                values.fileUpload = files[firstIndex]
              }
              if (action) {
                const rs = await action(values)
                if (!rs) {
                  toggle()
                  return
                }
                if (rs.isSuccess) {
                  toggle()
                }
              } else {
                toggle()
              }
            }
          }}
        />
      )}
    </div>
  )

  const upsertDisable = disabledAll ? [...disabled, ...monSetup.rsDiem] : disabled
  const options2 = {
    truongId: truongs.filter((item) => item.id !== 0),
    ketQua: ketQuas,
    // ...diemMonOptions(monThis),
  }
  const options3 = {
    heDaoTaoId: heDaoTaos.filter((item) => item.id !== 0),
    hinhThucDaoTaoId: hinhThucDaoTaos.filter((item) => item.id !== 0),
    donViDangKyDuThiId: donViDangKyDuThis.filter((item) => item.id !== 0),
    hoiDongId: hoiDongs.filter((item) => item.id !== 0),
    khoaThiId: khoaThis
      .filter((item) => item.id !== 0)
      .map((item) => {
        return { id: item.id, name: item.date }
      }),
  }
  const listFiles = values.fileDinhKem ? values.fileDinhKem.split(',') : []
  return (
    <>
      <Modal visible={visible} toggle={toggle} footer={footer}>
        <div className="flex flex-column">
          <div className="flex justify-content-start">
            <h4>Thông tin cá nhân</h4>
          </div>
          <Upsert
            values={values}
            setValues={setValues}
            fields={fields1}
            col={col1}
            error={error}
            setError={setError}
            name={name1}
            options={options1}
            types={types1}
            disable={upsertDisable}
            required={required1}
            maxLength={maxLength1}
          />
          <div className="flex justify-content-start">
            <h4>Thông tin học tập</h4>
          </div>
          <Upsert
            values={values}
            setValues={setValues}
            fields={fields2}
            col={col2}
            error={error}
            setError={setError}
            name={name2}
            options={options2}
            types={types2}
            disable={upsertDisable}
            required={required2}
            maxLength={maxLength2}
          />
          <div className="flex justify-content-start">
            <h4>Thông tin văn bằng</h4>
          </div>
          <Upsert
            values={values}
            setValues={setValues}
            fields={fields3}
            col={col3}
            error={error}
            setError={setError}
            name={name3}
            options={options3}
            types={types3}
            disable={upsertDisable}
            required={required3}
            maxLength={maxLength3}
          />
        </div>
        <div className="field">
          <p>Văn bản đính kèm</p>
          <div className="w-full">
            <input id="fileUploader" type="file" disabled={disabledAll} />
          </div>
        </div>
        <div className="flex flex-column">
          {listFiles.map((item) => {
            return (
              <div className="flex align-items-center">
                <a href={item} className="text-primary" download>
                  {item}
                </a>
                {!disabledAll && (
                  <i
                    className="pi pi-times ml-2"
                    onClick={() => {
                      const fileDinhKem = values.fileDinhKem.replace(item, '').replace(',,', ',')
                      setValues({ ...values, fileDinhKem })
                    }}
                  />
                )}
              </div>
            )
          })}
        </div>
      </Modal>
      {renderButton({ toggle, canEdit, btnProps })}
    </>
  )
}

export default ViewVanBang
